import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { CashInModal } from '../model/index';

@Injectable()
export class CashInService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    // private headers = new Headers({
    //    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'

    //     //'Content-Type': 'application/x-www-form-urlencoded charset=UTF-8', 'Accept': 'q=0.8;application/json;q=0.9'
    // });
    private cashIn = 'api/cashIn';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getCashInList(query: any): Promise<CashInModal[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.cashIn}/getCashInList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    addCashIn(query: any): Promise<CashInModal[]> {
        const url = `${this.cashIn}/addCashIn`;
        return this.http
            .post(url, $.param(query), { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    deleteCashIn(rowData: any): Promise<CashInModal> {
        const url = `${this.cashIn}/deleteCashInList`;
        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as CashInModal)
            .catch(this.handleError);
    }

    UpdateCashIn(testbilldetail: any): Promise<CashInModal> {

        const url = `${this.cashIn}/updateCashInData`;

        return this.http
            .post(url, $.param(testbilldetail), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as CashInModal)
            .catch(this.handleError);
    }

    getCashNoData(query: any): Promise<CashInModal[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.cashIn}/getCashOutNoDataList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/cashIn.service.ts